/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore } from 'vuex';
import axios from 'axios';
import { ITrailModel, TrailModel } from '@/types/routewebmodel';

export default createStore({
  state: {
    info: null as any,
    trailinfo: {} as ITrailModel,
    member: null as any,
    currentSubscriptions: null as any,
    modal: {
      msg: null as any,
      title: null as any,
      show: false as any,
    },
    usermessage: '',
    success: false,
  },
  getters: {
  },
  mutations: {
    updateInfo(state, data) {
      state.info = data;
    },
    updatetrailInfo(state, data) {
      const model = new TrailModel(data);
      model.init(data);
      state.trailinfo = model;
    },
    updateMember(state, data) {
      state.member = data;
    },
    updateCurrentSingleTrailSubscriptions(state, data) {
      console.log('zie data:');
      console.table(data);
      state.currentSubscriptions = data;
    },
    processResponse(state, data) {
      // Todo verplaatsen naar store.subscriber?
      if (data.RedirectUrl) {
        setTimeout(() => { window.location = data.RedirectUrl; }, 3000);
      }
      state.modal.title = data.Title;
      state.modal.msg = data.Message;
      state.modal.show = true;
    },
    processDonationPrepareResponse(state, data) {
      if (data.RedirectUrl) {
        setTimeout(() => { window.location = data.RedirectUrl; }, 3000);
      }
      state.modal.title = data.Title;
      state.modal.msg = data.Message;
      state.modal.show = true;
    },
    processConfirmEmailAddressResponse(state, data: any) {
      if (data.success) {
        state.modal.title = data.Title;
        state.modal.msg = data.Message;
        state.modal.show = true;
      } else {
        state.success = false;
        state.usermessage = `Helaas ${data.message}`;
      }
    },
  },
  actions: {
    getInfo({ commit }, origin) {
      if (origin) {
        axios.get(`/umbraco/api/subscription/getsingletrailsubscriptioninfo?productid=34&origin=${origin}`)
          .then((result) => commit('updateInfo', result.data));
      }
    },
    getTrailIntroduction({ commit }, trailid) {
      if (trailid) {
        console.log('get trail introduction');
        axios.get(`/umbraco/api/gateway/getroute?apiUrl=intro&routeId=${trailid}`)
          .then((result) => commit('updatetrailInfo', result.data));
      }
    },
    getTrailDescription({ commit }, trailid) {
      if (trailid) {
        axios.get(`/umbraco/api/gateway/getroute?apiUrl=description&routeId=${trailid}`)
          .then((result) => commit('updatetrailInfo', result.data));
      }
    },
    getMember({ commit }) {
      return axios.get('/umbraco/api/member/get')
        .then((result) => commit('updateMember', result.data));
    },
    postSubscription({ commit }, data) {
      axios.post('/umbraco/api/subscription/postsingletrailsubscription', data)
        .then((result) => commit('processResponse', result.data));
    },
    getCurrentSingleTrailSubscriptions({ commit }) {
      axios.get('/umbraco/api/member/getcurrentsingletrailsubscriptions')
        .then((result) => commit('updateCurrentSingleTrailSubscriptions', result.data));
    },
    postDonationPrepare({ commit }, data) {
      axios.post('/umbraco/api/Gateway/DonationPrepare', data)
        .then((result) => commit('processDonationPrepareResponse', result.data));
    },
    postConfirmEmailAddress({ commit }, data) {
      // eslint-disable-next-line
      return axios.post('/umbraco/api/Gateway/ConfirmEmailAddress', data)
        .then((result) => commit('processConfirmEmailAddressResponse', result.data));
    },
    hideServerMessage() {
      // this.modal.show = false;
    },
  },
  modules: {
  },
});
